<template lang="html">
  <div class="info-memo--inner">
    <h2 class="user-details--title">
      <button class="btn--create" @click="showCreate=true">
        <i class="ico--create"></i>
      </button>
      Memos
    </h2>

    <div class="user-details-toolbar">
      <div class="user-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="selectedList"
          v-model="selectedList"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="undeleted"
            name="undeleted"
          >
            <span>undeleted</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
            <span>deleted</span>
          </select-option>

        </select-list>
        <search
          class="search-bar-wrap"
          :filterBy="filterBy"
          :dateBy="dateBy"
          :rows="params.rows"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
      </div>
    </div>

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>

    <tbl
      :scrollable="true"
      :class="{ 'data-loading': showDataLoading }"
      v-else
    >
      <tbl-inner>
        <tbl-head>
          <tbl-row>
            <tbl-td
              :sort="true"
              @click.native="sort('id')"
              name="no"
            >
              date
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('created_at')"
              name="date">
              date
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('memo')"
              name="note">
              memo
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('admins.login_name')"
              name="writer">
              writer
            </tbl-td>

            <tbl-td name="actions">
              actions
            </tbl-td>
          </tbl-row>
        </tbl-head>
        <tbl-body>
          <tbl-row
            v-for="(memo, x) in memos"
            :key="memo.id"
            :class="{'is-deleted': memo.deleted_at }"
          >
            <tbl-td name="no">
              {{ generateNumber(x, params.page, params.rows, params.sort, count || 0) }}
            </tbl-td>

            <tbl-td name="date">
              {{memo.created_at | date}}
            </tbl-td>

            <tbl-td name="note">
              {{memo.memo}}
            </tbl-td>

            <tbl-td name="writer">
              {{memo.admin_login_id}}
            </tbl-td>

            <tbl-td name="actions">
              <button
                class="btn--bookmark"
                v-if="!memo.deleted_at"
                :class="{'-main': memo.is_favorite}"
                @click="setFavorite(memo)"
              >
                <i class="ico--bookmark"></i>
              </button>

              <button
                class="btn--delete"
                @click="remove(memo.id)"
                v-if="!memo.deleted_at"
              >
                <i class="ico--delete"></i>
              </button>
            </tbl-td>
          </tbl-row>
        </tbl-body>
      </tbl-inner>
      <tbl-footer>
        <pagination
          :total="count"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>
    </tbl>

    <modal
      class="modal--create-memo"
      :title="'create memo'"
      :activate="showCreate"
      v-if="showCreate"
      @activate="showCreate=$event"
    >
      <template slot="body">
        <div class="details details-modal">
          <div class="detail-items">
            <div class="detail-lbl">
              <span>memo</span>
            </div>
            <div class="detail-data -disabled">
              <div class="textarea-wrap">
                <text-area  v-model="memo"></text-area>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--create -withlabel"
          @click="save()"
        >
          <i class="ico--create"></i>
          <span>create memo</span>
        </button>
      </template>
    </modal>

  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
//= components
import '@/components/base/table/Table'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import Pagination from '@/components/base/Pagination'
import TextArea from '@/components/base/TextArea'

import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'

export default {
  name: 'info-memo',

  components: {
    Search,
    Modal,
    CheckDataList,
    Pagination,
    TextArea
  },

  mixins: [ swal, getListStatus ],

  data () {
    let params = Object.assign(
      {
        rows: 10,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: '',
        date_by: ''
      },
      this.$route.query
    )

    return {
      params,
      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      selectedList: this.$route.params.subtype,

      filterBy: [
        {
          value: 'date',
          display: 'date'
        },

        {
          value: 'memo',
          display: 'memo'
        },

        {
          value: 'writer',
          display: 'writer'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      showCreate: false,
      memo: ''
    }
  },

  async created () {
    this.params.rows = 10
    this.search(this.generate(this.params))
  },

  computed: {
    ...mapState('agentMemo', ['memos', 'count']),
    ...mapState('agent', ['agent'])
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  methods: {
    ...mapActions('agentMemo', ['create', 'get', 'delete', 'update']),

    async trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    }, // trigger

    async search (query) {
      console.log('search')
      this.params = query || this.params
      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }
      this.params.rows = 10
      await this.get({ id: this.$route.params.id, params: this.params, status: this.$route.params.subtype })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.memos.length) {
        this.isEmpty = true
      }
    }, // search

    async save () {
      if (this.memo.trim() === '') {
        this.$alert('error', 'check data', '', '', 'Error')
        return
      }

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.create({
        id: this.agent.id,
        memo: this.memo
      })

      this.showDataLoading = false
      this.search()

      this.showCreate = false
      this.memo = ''
    },

    async remove (id) {
      this.$alert('prompt', 'Are  you sure?', '', async () => {
        try {
          await this.delete({
            mid: id,
            uid: this.agent.id
          })

          this.$alert('success', 'Deleted', {}, '', 'Deleted')
          this.search()
        } catch (err) {

        }
      }, 'Delete?')
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.$router.push({ query: this.params })
    },

    async setFavorite (data) {
      try {
        await this.update({
          mid: data.id,
          uid: this.agent.id,
          data: { is_favorite: !data.is_favorite }
        })

        this.$alert('success', 'Success', {}, '', 'Updated')

        this.search()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>
</style>
